import RoomCatapultEdit from './RoomCatapultEdit.vue';
import RoomCatapult from './RoomCatapult.vue';
export { RoomCatapultEdit };
export default RoomCatapult;
